import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PELanguagesCardActions = {
  initPeLanguagesCard: ({ commit }, index) => {
    commit('setPeLanguagesCardLock', { index, lock: true })
  },
  peLanguagesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        learned_languages: {
          party_id: party.id,
          language_id: section.language_id,
          primary: section.primary,
          reading: section.reading,
          writing: section.writing,
          speaking: section.speaking,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          learned_languages: updatedParty.learned_languages || [],
        })
      }).
      catch(handleError)
  },
  peLanguagesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/learned_languages/${section.id}`).
      then(({ data }) => {
        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'learned_languages',
          value: data,
        })
      }).
      catch(handleError)
  },
  peLanguagesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        learned_languages: {
          party_id: party.id,
          language_id: section.language_id,
          primary: section.primary,
          reading: section.reading,
          writing: section.writing,
          speaking: section.speaking,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          learned_languages: updatedParty.learned_languages || [],
        })
      }).
      catch(handleError)
  },
  peLanguagesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          learned_languages: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          learned_languages: updatedParty.learned_languages || [],
        })
      }).
      catch(handleError)
  },
  peLanguagesCardAddSection: ({ commit }) => {
    commit('setPeLanguagesCardLock', { index: 'new', lock: false })
    commit('addPeLanguagesCardSection', {
      id: null,
      language_id: null,
      primary: null,
      reading: null,
      writing: null,
      speaking: null,
    })
  },
}

export const PELanguagesCardMutations = {
  setPeLanguagesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.LanguagesCard) Vue.set(state.partyEdit.partySections, 'LanguagesCard', {})
    Vue.set(state.partyEdit.partySections.LanguagesCard, index, lock)
  },
  addPeLanguagesCardSection: (state, section) => {
    state.partyEdit.party.learned_languages.push(section)
  },
  peLanguagesCardCreateUndo: state => state.partyEdit.party.learned_languages.pop(),
}

export const PELanguagesCardGetters = {
  peLanguagesCardLock: state => index => state.partyEdit.partySections.LanguagesCard[index],
  peLanguagesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    learned_languages?.
    find(language => language.id === null),
}
